/**
 * SDK 滑块验证码 API(同源 BFF 调用)
 *
 * 走 hotel-hub 同源 BFF /api/captcha/*(BFF callUpstream 服务端推导 -> whapi,公开端点无 X-API-Key、
 * 无需登录)。用 sdk client 的 get/post(自动带 basePath + domain 透传)。
 */
import type {
  SlideCaptchaGenerateResponse,
  SlideCaptchaValidateParams,
  SlideCaptchaValidateResponse,
} from '@/types/captcha';
import { get, post } from './client';

/** 生成滑块验证码(返回 id + 背景图/滑块图) */
export function generateSlideCaptcha(): Promise<SlideCaptchaGenerateResponse> {
  return get<SlideCaptchaGenerateResponse>('/api/captcha/generate');
}

/** 校验滑块验证码(返回 token,供 sendSmsCode 的 slideCaptchaToken 用) */
export function validateSlideCaptcha(
  params: SlideCaptchaValidateParams
): Promise<SlideCaptchaValidateResponse> {
  return post<SlideCaptchaValidateResponse>('/api/captcha/validate', params);
}
